import { BaseModel } from "sjs-base-model";

export default class DatiGiuridiciModel extends BaseModel {
    public readonly dataInizioPagamentiSPT: string = "";
    public readonly anzianitaServizioAnni: number = 0;
    public readonly anzianitaServizioMesi: number = 0;
    public readonly codDurataRapportoLavoro: number = 0;
    public readonly tipoDurataRapportoLavoro: string = "";
    public readonly codOrarioRapportoLavoro: number = 0;
    public readonly tipoOrarioRapportoLavoro: string = "";
    public readonly causaleScadenzaPagamenti: string = "";
    public readonly dataScadenzaPagamenti: string = "";
    public readonly ultimaPds: string = "";
    public readonly dataDecorrenzaPds: string = "";
    public readonly dataScadenzaPds: string = "";

    constructor(data: Partial<DatiGiuridiciModel>) {
        super();

        this.update(data);
    }
}
